<template>
  <div class="report-skeleton" role="status" aria-label="Đang tải báo cáo coi thi">
    <div v-for="metric in 2" :key="`metric-${metric}`" class="skeleton-card">
      <header class="skeleton-card__header">
        <el-skeleton-item variant="text" style="width: 140px; height: 18px;" />
        <el-skeleton-item variant="rect" style="width: 76px; height: 24px; border-radius: 13px;" />
      </header>

      <div class="skeleton-stats">
        <div v-for="stat in 2" :key="`stat-${metric}-${stat}`" class="skeleton-stat-box">
          <div class="skeleton-stat-box__top">
            <el-skeleton-item variant="text" style="width: 60px; height: 26px;" />
            <el-skeleton-item variant="text" style="width: 38px; height: 14px;" />
          </div>
          <el-skeleton-item variant="text" style="width: 56px; height: 12px; margin-top: 8px;" />
          <el-skeleton-item variant="text" style="width: 34px; height: 20px; margin-top: 6px;" />
          <div class="skeleton-stat-box__row">
            <el-skeleton-item variant="text" style="width: 42px; height: 12px;" />
            <el-skeleton-item variant="text" style="width: 18px; height: 12px;" />
          </div>
          <div class="skeleton-stat-box__row">
            <el-skeleton-item variant="text" style="width: 34px; height: 12px;" />
            <el-skeleton-item variant="text" style="width: 18px; height: 12px;" />
          </div>
        </div>
      </div>

      <div class="skeleton-activity">
        <el-skeleton-item variant="text" style="width: 100px; height: 13px; margin-bottom: 10px;" />
        <div v-for="row in 6" :key="`row-${metric}-${row}`" class="skeleton-activity__row">
          <el-skeleton-item variant="text" style="width: 34px; height: 12px;" />
          <el-skeleton-item variant="text" :style="{width: row % 2 ? '82%' : '58%', height: '12px'}" />
          <el-skeleton-item variant="rect" style="width: 46px; height: 18px; border-radius: 9px; justify-self: end;" />
        </div>
      </div>
    </div>

    <div class="skeleton-card skeleton-card--ranking">
      <header class="skeleton-card__header">
        <el-skeleton-item variant="circle" style="width: 18px; height: 18px;" />
        <el-skeleton-item variant="text" style="width: 96px; height: 18px;" />
      </header>

      <div class="skeleton-ranking">
        <div v-for="row in 6" :key="`rank-${row}`" class="skeleton-ranking__row">
          <el-skeleton-item variant="circle" style="width: 24px; height: 24px;" />
          <div class="skeleton-ranking__info">
            <el-skeleton-item variant="text" :style="{width: row === 1 ? '75%' : '55%', height: '14px'}" />
            <el-skeleton-item variant="text" style="width: 40%; height: 11px; margin-top: 6px;" />
          </div>
          <el-skeleton-item variant="text" style="width: 22px; height: 18px;" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportSkeleton'
};
</script>

<style scoped lang="scss" src="./ReportSkeleton.scss"></style>
